import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import {Link, withRouter} from 'react-router-dom'

import {FaStar} from 'react-icons/fa'
import Header from '../Header/Header'
import './JobsRoute.css'

const employmentTypesList = [
  {label: 'Full Time', employmentTypeId: 'FULLTIME'},
  {label: 'Part Time', employmentTypeId: 'PARTTIME'},
  {label: 'Freelance', employmentTypeId: 'FREELANCE'},
  {label: 'Internship', employmentTypeId: 'INTERNSHIP'},
]

const salaryRangesList = [
  {salaryRangeId: '1000000', label: '10 LPA and above'},
  {salaryRangeId: '2000000', label: '20 LPA and above'},
  {salaryRangeId: '3000000', label: '30 LPA and above'},
  {salaryRangeId: '4000000', label: '40 LPA and above'},
]

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class JobsRoute extends Component {
  state = {
    profileData: {},
    jobsList: [],
    employmentTypes: [],
    salaryRange: '',
    searchInput: '',
    profileApiStatus: apiStatusConstants.initial,
    jobsApiStatus: apiStatusConstants.initial,
  }

  componentDidMount() {
    this.fetchProfileData()
    this.fetchJobsData()
  }

  fetchProfileData = async () => {
    this.setState({profileApiStatus: apiStatusConstants.inProgress})
    const jwtToken = Cookies.get('jwt_token')
    const url = 'https://apis.ccbp.in/profile'
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }
    const response = await fetch(url, options)
    if (response.ok) {
      const data = await response.json()
      this.setState({
        profileData: data.profile_details,
        profileApiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({profileApiStatus: apiStatusConstants.failure})
    }
  }

  fetchJobsData = async () => {
    this.setState({jobsApiStatus: apiStatusConstants.inProgress})
    const {employmentTypes, salaryRange, searchInput} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const url = `https://apis.ccbp.in/jobs?employment_type=${employmentTypes.join(
      ',',
    )}&minimum_package=${salaryRange}&search=${searchInput}`
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }
    const response = await fetch(url, options)
    if (response.ok) {
      const data = await response.json()
      this.setState({
        jobsList: data.jobs,
        jobsApiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({jobsApiStatus: apiStatusConstants.failure})
    }
  }

  handleEmploymentTypeChange = event => {
    const {employmentTypes} = this.state
    const {value, checked} = event.target
    const updatedEmploymentTypes = checked
      ? [...employmentTypes, value]
      : employmentTypes.filter(type => type !== value)
    this.setState({employmentTypes: updatedEmploymentTypes}, this.fetchJobsData)
  }

  handleSalaryRangeChange = event => {
    this.setState({salaryRange: event.target.value}, this.fetchJobsData)
  }

  handleSearchInputChange = event => {
    this.setState({searchInput: event.target.value})
  }

  handleSearchSubmit = event => {
    event.preventDefault()
    this.fetchJobsData()
  }

  renderProfileSection = () => {
    const {profileApiStatus, profileData} = this.state
    switch (profileApiStatus) {
      case apiStatusConstants.success:
        return (
          <div className="profile-card">
            <img src={profileData.profile_image_url} alt="profile" />
            <h3>{profileData.name}</h3>
            <p>{profileData.short_bio}</p>
          </div>
        )
      case apiStatusConstants.failure:
        return (
          <button type="button" onClick={this.fetchProfileData}>
            Retry
          </button>
        )
      case apiStatusConstants.inProgress:
        return (
          <Loader
            data-testid="loader"
            type="ThreeDots"
            color="#ffffff"
            height={50}
            width={50}
          />
        )
      default:
        return null
    }
  }

  renderJobsContent = () => {
    const {jobsApiStatus, jobsList} = this.state
    if (jobsApiStatus === apiStatusConstants.success) {
      return jobsList.length > 0 ? (
        <ul>
          {jobsList.map(job => (
            <li key={job.id}>
              <Link to={`/jobs/${job.id}`} className="job-link">
                <div className="job-card">
                  <img src={job.company_logo_url} alt="company logo" />
                  <h3>{job.title}</h3>
                  <p>
                    <FaStar color="gold" /> {job.rating}
                  </p>
                  <p>
                    {job.location} | {job.employment_type}
                  </p>
                  <p>{job.package_per_annum}</p>
                  <h1>Description</h1>
                  <p>{job.job_description}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        jobsList.length === 0 && (
          <div className="no-jobs-container">
            <img
              src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
              alt="no jobs"
            />
            <h1>No Jobs Found</h1>
            <p>We could not find any jobs, try other filters.</p>
          </div>
        )
      )
    }

    if (jobsApiStatus === apiStatusConstants.failure) {
      return (
        <button type="button" onClick={this.fetchJobsData}>
          Retry
        </button>
      )
    }
    if (jobsApiStatus === apiStatusConstants.inProgress) {
      return (
        <Loader
          data-testid="loader"
          type="ThreeDots"
          color="#ffffff"
          height={50}
          width={50}
        />
      )
    }
    return null
  }

  render() {
    return (
      <div className="jobs-container">
        <Header />
        <aside className="filters-section">
          {this.renderProfileSection()}
          <h3>Type of Employment</h3>
          <ul>
            {employmentTypesList.map(type => (
              <li key={type.employmentTypeId}>
                <label>
                  <input
                    type="checkbox"
                    value={type.employmentTypeId}
                    onChange={this.handleEmploymentTypeChange}
                  />{' '}
                  {type.label}
                </label>
              </li>
            ))}
          </ul>

          <h1>Salary Range</h1>
          <ul>
            {salaryRangesList.map(salary => (
              <li key={salary.salaryRangeId}>
                <label>
                  <input
                    type="radio"
                    name="salaryRange"
                    value={salary.salaryRangeId}
                    onChange={this.handleSalaryRangeChange}
                  />{' '}
                  {salary.label}
                </label>
              </li>
            ))}
          </ul>
        </aside>
        <main className="jobs-section">
          <form onSubmit={this.handleSearchSubmit}>
            <input
              type="search"
              onChange={this.handleSearchInputChange}
              placeholder="Search for jobs..."
            />
            <button type="button" data-testid="searchButton">
              Search
            </button>
          </form>
          {this.renderJobsContent()}
        </main>
      </div>
    )
  }
}
export default withRouter(JobsRoute)
